<!-- <div class="card flex justify-center">
  <p-button (click)="toggleDarkMode()" label="Check" />
</div> -->

<div class="w-full h-[100vh] flex items-start overflow-hidden">
  <router-outlet />

  <p-toast [baseZIndex]="100" key="nService" />
  <p-toast [baseZIndex]="100" key="loadingApi" />
  <p-toast
    [baseZIndex]="100"
    key="progressApi"
    [preventDuplicates]="true"
    [preventOpenDuplicates]="true"
    [showTransitionOptions]="'0ms ease-out'"
    [hideTransitionOptions]="'0ms ease-in'"
  />
</div>
